import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import AccessControl from "../../helpers/acessControl";

const MerchantList = (props:any) => {
  const { handleIsActive } = props
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "user_info.profile.full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "user_info.email",
      cell: NACell,
    },
    {
      header: "VAT/PAN",
      accessorKey: "vat_pan",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "user_info.mobile_number",
      cell: NACell,
    },

    {
      header: "Active",
      accessorKey: "user_info.is_active",
      cell: ({ row, getValue }) => (
        <AccessControl children={<SwitchButton
          id={row?.original?.user}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />}
          allowedPermissions={["can_update_user"]}
          renderNoAccess={<SwitchButton
            id={row?.original?.user}
            value={getValue()}
            disabled={true}
            onChange={handleIsActive}
          />}
        />
      )
    },
  
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }:any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.MERCHANT}
        queryKey={"merchant"}
        columns={defaultColumns}
        addNewPagePath={"create"}
        tableName={"Merchant"}
      />
    </>
  );
};

export default MerchantList;
